export const contactsData = {
    email: 'bonifacekamau87@gmail.com',
    phone: '+254 727851941',
    address: 'Village Market, Kenya - 00621 ',

    sheetAPI: ''
}